import { Select } from 'antd';
import React from 'react';

const bookingPurposes = [
  'Thuê xe cưới',
  'Du lịch',
  'Về quê',
  'Công tác',
  'Thuê cho công ty',
  'Cá nhân',
  'Ngoại giao',
  'Đi sự kiện',
  'KXD',
  'Khác',
];

type Props = {
  onChange: (selected: string) => void;
  value: string;
};

function RentPurposeSelect(props: Props) {
  return (
    <Select
      showSearch
      value={props.value}
      onChange={props.onChange}
      options={bookingPurposes
        .sort((a, b) => a.localeCompare(b))
        .map((p) => ({ label: p, value: p }))}
    />
  );
}

export default RentPurposeSelect;
